import { render, staticRenderFns } from "./LayoutTemplate.vue?vue&type=template&id=4779322b"
import script from "./LayoutTemplate.vue?vue&type=script&lang=js"
export * from "./LayoutTemplate.vue?vue&type=script&lang=js"
import style0 from "./LayoutTemplate.vue?vue&type=style&index=0&id=4779322b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports